import React, { Component } from 'react';

var google;

class GoogleMap extends Component {

  state = { zoom: 15 };

  static propTypes = {
    initialCenter: React.PropTypes.objectOf(React.PropTypes.number).isRequired
  }

    render() {
    return <div className="google-map">
      <div className='GMap-canvas' ref="mapCanvas">
      </div>
    </div>
  }

  componentDidMount() {
    
    let loader = document.createElement('script');
    loader.src = "http://maps.googleapis.com/maps/api/js?key=AIzaSyC6uyRqo17t1bdcERW5zBM0m-NxBuVAXJA";


    loader.onload = () => {

      google = window.google;
      // create the map, marker and infoWindow after the component has
      // been rendered because we need to manipulate the DOM for Google =(
      this.map = this.createMap()
      this.marker = this.createMarker()
      // this.infoWindow = this.createInfoWindow()
    
      // have to define google maps event listeners here too
      // because we can't add listeners on the map until its created
      google.maps.event.addListener(this.map, 'zoom_changed', ()=> this.handleZoomChange())

    }

    document.getElementsByTagName('head')[0].appendChild(loader);


  }

  // clean up event listeners when component unmounts
  componentDidUnMount() {
    google.maps.event.clearListeners(this.map, 'zoom_changed')
  }

  createMap() {
    let mapOptions = {
      draggable: !("ontouchend" in document),
      zoom: this.state.zoom,
      center: this.mapCenter(),
      panControl:false,
      zoomControl:true,
      scaleControl:false,
      streetViewControl:true,
      overviewMapControl:false,
      rotateControl:false,
      scrollwheel: false
    }

    var map = new google.maps.Map(this.refs.mapCanvas, mapOptions);
    return map;
  }

  mapCenter() {
    return new google.maps.LatLng(
      this.props.initialCenter.lat,
      this.props.initialCenter.lng
    )
  }

  createMarker() {
    return new google.maps.Marker({
      position: this.mapCenter(),
      map: this.map,
      icon: 'Gmap_marker.png'
    })
  }

  createInfoWindow() {
    let contentString = "<div class='InfoWindow'>I'm a Window that contains Info Yay</div>"
    return new google.maps.InfoWindow({
      map: this.map,
      anchor: this.marker,
      content: contentString
    })
  }
  
  handleZoomChange() {
    this.setState({
      zoom: this.map.getZoom()
    })
  }

}


export default GoogleMap;


/** WEBPACK FOOTER **
 ** ./src/components/GoogleMap.jsx
 **/